export default __webpack_public_path__ + "static/media/discovery-img.41eaefaa.png";